module.exports = __webpack_public_path__ + "static/28D-desktop-bkgd-7aac86cd12324c07c5f40f018191cdb4.jpg";